import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { getListingCategoryLabels } from '../../../util/listingPageContent';

import css from './ListingPageSections.module.css';

/**
 * Breadcrumb trail for the listing page.
 *
 * @component
 */
const SectionBreadcrumbs = props => {
  const { title, publicData, categoryConfiguration, className, rootClassName } = props;
  const categories = getListingCategoryLabels(publicData, categoryConfiguration);
  const classes = classNames(rootClassName || css.breadcrumbs, className);

  const lastCategory = categories[categories.length - 1];

  return (
    <nav className={classes} aria-label="Breadcrumb">
      <NamedLink name="LandingPage" className={css.breadcrumbLink}>
        <FormattedMessage id="ListingPage.breadcrumbHome" />
      </NamedLink>
      <span className={css.breadcrumbSep}> / </span>
      <NamedLink name="SearchPage" className={css.breadcrumbLink}>
        <FormattedMessage id="ListingPage.breadcrumbSearch" />
      </NamedLink>
      {lastCategory ? (
        <>
          <span className={css.breadcrumbSep}> / </span>
          <NamedLink
            name="SearchPage"
            to={{ search: `?pub_categoryLevel1=${encodeURIComponent(lastCategory.id)}` }}
            className={css.breadcrumbLink}
          >
            {lastCategory.name}
          </NamedLink>
        </>
      ) : null}
      {title ? (
        <>
          <span className={css.breadcrumbSep}> / </span>
          <span className={css.breadcrumbCurrent}>{title}</span>
        </>
      ) : null}
    </nav>
  );
};

export default SectionBreadcrumbs;
